import React, { useContext } from 'react';
import Context from './globalStates';

const useAppContext = () => useContext(Context);

export default useAppContext;